/**
 * Ryan O'Dowd
 * 2021-12-27
 * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import globals from '@utils/globals';

const getStyles = ({globalScale, colors, isDarkMode, safeAreaInsets}) => {
  return {
    mainListContainer: {
      flexGrow: 1,
      gap: 4,
      paddingBottom: safeAreaInsets.bottom + 4,
    },
    subHeaderWrapper: {
      display: 'flex',
      alignItems: 'flex-end',
      paddingRight: 8,
      paddingBottom: 8,
    },
    versionNumberText: {
      display: 'flex',
      fontSize: globalScale * 16,
      color: globals.appName === 'wrinkly' ? colors.white : isDarkMode ? colors.white : colors.black,
    },
    versionBadge: {
      position: 'absolute',
      top: globalScale * -4,
      right: globalScale * -4,
      backgroundColor: colors.alert,
      width: globalScale * 12,
      height: globalScale * 12,
      borderRadius: globalScale * 6,
    },
    popoverText: {
      fontSize: globalScale * 16,
      color: isDarkMode ? colors.white : colors.black,
      padding: globalScale * 8,
    },
  };
};

export default getStyles;
